const greeting = {
  title: "Gurshaanpreet Singh",
  logo_name: "Gurshaanpreet Singh",
  nickname: "",
  subTitle:
    "Current Student at Dr. B.R. Ambedkar National Institute of Technology | Aspiring Full-Stack Developer.",
  resumeLink:
    "https://drive.google.com/file/d/14zuV9c8W6g_iphjPY7aWIEj9xjMkvLtu/view?usp=drive_link",
  portfolio_repository: "https://github.com/Gurshaan-1/portfolio1",
  githubProfile: "https://github.com/Gurshaan-1",
};

const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/Gurshaan-1",
    fontAwesomeIcon: "fa-github",
    backgroundColor: "#181717",
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/gurshaanpreet-singh-54b190280/",
    fontAwesomeIcon: "fa-linkedin-in",
    backgroundColor: "#0077B5",
  },

  {
    name: "Gmail",
    link: "mailto:gurshaan1507@gmail.com",
    fontAwesomeIcon: "fa-google",
    backgroundColor: "#D14836",
  },

  {
    name: "Instagram",
    link: "https://www.instagram.com/gurshaan.__/?hl=en",
    fontAwesomeIcon: "fa-instagram",
    backgroundColor: "#E4405F",
  },
];

const skills = {
  data: [
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building responsive website front end using ReactJs",
        "⚡ Creating application backend in Node & Express",
        "⚡ I enjoy building user-friendly and scalable web applications from the ground up, utilizing the power of this versatile technology stack.",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "devicon-plain:nodejs-wordmark",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "ExpressJS",
          fontAwesomeClassname: "simple-icons:express",
          style: {
            color: "#47A248",
          },
        },
      ],
    },
    {
      title: "Data Analysis & Computer Vision",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Proficient in OpenCV and Python for image manipulation, object detection, and computer vision tasks.",
        "⚡ Possess experience in building and applying machine learning models for data analysis using Python libraries.",
        "⚡ Skilled in data analysis and visualization using Python libraries and software like Orange.",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },

        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Orange",
          imageSrc: "orange.png",
        },
        {
          skillName: "Jupyter",
          fontAwesomeClassname: "logos-jupyter",
        },
      ],
    },
  ],
};

const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://leetcode.com/gurshaan_1/",
    },
    {
      siteName: "CodingNinjas",
      iconifyClassname: "simple-icons:codingninjas",
      style: {
        color: "#ee964b",
      },
      profileLink:
        "https://www.naukri.com/code360/profile/d123e701-e23f-480e-b102-494e16d47686",
    },
    {
      siteName: "Codechef",
      iconifyClassname: "simple-icons:codechef",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://www.codechef.com/users/gurshaan_1",
    },
    {
      siteName: "Codeforces",
      iconifyClassname: "simple-icons:codeforces",
      style: {
        color: "#1F8ACB",
      },
      profileLink: "https://codeforces.com/profile/gurshaan_1",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Dr. B.R. Ambedkar National Institute of Technology , Jalandhar",
      subtitle: "B.Tech. in Computer Science & Engineering",
      logo_path: "nitjlogo.png",
      alt_name: "NIT JALANDHAR",
      duration: "2021 - Present",
      descriptions: [
        "⚡ Entering my final year with a strong academic foundation (CGPA: 8.30) and a passion for computer science. ",
        "⚡ Possess a solid grasp of core concepts like OOPS, DBMS, Computer Vision, Web Development, and Software Engineering.",
        "⚡ Eager to leverage my knowledge and apply it to real-world projects as I embark on my final year.",
      ],
      website_link: "https://www.nitj.ac.in/",
    },
    {
      title: "Amarpuri Sr. Sec. Public School , Goindwal Sahib",
      subtitle: "High School",
      logo_path: "appslogo.png",
      alt_name: "APPS",
      duration: "2013 - 2021",
      descriptions: [
        "⚡ Consistent academic performance with 91% in 10th and 92.6% in 12th grade.",
        "⚡ Secured district rank 3rd in a state-level olympiad and cleared NTSE in 10th grade, demonstrating a passion for learning beyond the classroom.",
        "⚡  Awarded a merit-based scholarship of ₹25k from my school, acknowledging my academic excellence.",
      ],
      website_link:
        "https://school.careers360.com/schools/amarpuri-public-school-sri-goindwal-sahib-tarn-taran",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "CodeRush Ceritifcation",
      subtitle: "- AlgoUniversity",
      logo_path: "algo.png",
      certificate_link:
        "https://d3uam8jk4sa4y4.cloudfront.net/static/certificates/40/Gurshaanpreet%20Singh.png",
      alt_name: "CodeRush Certificate",
      color_code: "#8C151599",
    },
    {
      title: "Python Cerificate",
      subtitle: "- GUVI",
      logo_path: "guvi.png",
      certificate_link:
        "https://www.guvi.in/certificate?id=71he184aI68Bp1R169&download=true",
      alt_name: "python",
      color_code: "#ffffff",
    },
    {
      title: "Web Development",
      subtitle: "- EduReka",
      logo_path: "edureka.png",
      certificate_link:
        "https://onedrive.live.com/?authkey=%21AJ9EfmnPF0sx1K8&id=FF26E9DA3A10F814%211456&cid=FF26E9DA3A10F814&parId=root&parQt=sharedby&o=OneUp",
      alt_name: "Web Development",
      color_code: "#d9dcd6",
    },
    {
      title: "Flipkart Grid Round 2",
      subtitle: "- Flipkart",
      logo_path: "fpg.png",
      certificate_link:
        "https://drive.google.com/file/d/1Ey3UzT2e6g7ENNP15Hkfl4-NPrwUp2ye/view",
      alt_name: "Unstop",
      color_code: "#000000",
    },
    {
      title: "Xiaomi Ode Round 2",
      subtitle: "- Xiaomi",
      logo_path: "xiaomi.png",
      certificate_link:
        "https://drive.google.com/file/d/1r1Uo8IlIaMOpbVXYbWGP3U31evlue7RP/view",
      alt_name: "Unstop",
      color_code: "#fb8b24",
    },
    {
      title: "Campus Ambassador IIT-BHU",
      subtitle: "- IIT-BHU",
      logo_path: "iitbhu.png",
      certificate_link:
        "https://drive.google.com/file/d/1hvVsnugmO-3r-eiMX0UFjJd_bqKaWkOV/view",
      alt_name: "IIT_BHU",
      color_code: "#8C151599",
    },
  ],
};

const experience = {
  title: "Experience",
  subtitle: "",
  description:
    " Combining freelance & internship experience for holistic growth. I have worked with some evolving startups as Web Developer & Designer.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      work: true,
      experiences: [
        {
          title: "Freelancer",
          company: "A Freelancing Project",
          company_url: "https://github.com/Gurshaan-1/task-management",
          logo_path: "freelance.svg",
          duration: "April 2024 - May 2024",
          location: "Punjab , India",
          description:
            " Built a robust task management system as a freelancer for smooth workflows, facilitating efficient collaboration between clients and admins.Implemented features like admin-assigned tasks, deadline management, file upload/download capabilities, and notification systems for streamlined project communication.",
          color: "#000000",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Web Development Intern",
          company: "Navodita Infotech",
          company_url: "https://navoditainfotech.com/",
          logo_path: "navodita.jpeg",
          duration: "June 2024 - Present",
          location: "Punjab , India",
          description:
            " Honing my skills across the entire development stack building a real-world e-commerce application using React for a dynamic front-end, Node.js for a robust back-end, and MongoDB for scalable data storage.",
          color: "#000000",
        },
      ],
    },
  ],
};

const projectsHeader = {
  title: "Projects",
  description:
    "Dive into my creations: Explore a curated selection of projects showcasing my skills and design thinking process.",
  avatar_image_path: "projects_image.svg",
};

const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "profile.jpg",
    description:
      "Stay connected and explore further! I am available on the following platforms , You can follow for updates, insights, and a glimpse into my work journey.",
  },
};

export {
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
};
